import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { startStripeCheckout } from "../../actions/stripeActions";
import UserNav from "../UserDashboard/UserNav";

class StripeCheckoutTest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      products: {
        courses: [],
        subscriptions: [],
        pas: null
      },
      productError: null
    };

    this.startCheckout = this.startCheckout.bind(this);
    this.startPasCheckout = this.startPasCheckout.bind(this);
  }

  componentDidMount() {
    axios
      .get("/api/stripe/products")
      .then(res => {
        this.setState({
          loading: false,
          products: res.data
        });
      })
      .catch(err => {
        this.setState({
          loading: false,
          productError:
            err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : err.message
        });
      });
  }

  startCheckout(product) {
    this.props.startStripeCheckout({
      purchaseType: product.purchaseType,
      targetId: product._id
    });
  }

  startPasCheckout() {
    this.props.startStripeCheckout({
      purchaseType: "pas"
    });
  }

  renderProductList(title, products) {
    if (products.length === 0) {
      return (
        <div>
          <h2>{title}</h2>
          <p>No Stripe-linked products found.</p>
        </div>
      );
    }

    return (
      <div>
        <h2>{title}</h2>
        <div className="checkout-product-list">
          {products.map(product => (
            <div className="checkout-product-row" key={product._id}>
              <span>{product.name}</span>
              <button
                className="btn btn-pp"
                onClick={() => this.startCheckout(product)}
              >
                Checkout
              </button>
            </div>
          ))}
        </div>
      </div>
    );
  }

  render() {
    const { loading, products, productError } = this.state;

    return (
      <div>
        <UserNav />
        <div className="wrapper-alt">
          <div className="container checkout-test">
            <h1>Stripe Checkout</h1>

            {this.props.errors && this.props.errors.message ? (
              <div className="alert alert-danger">{this.props.errors.message}</div>
            ) : null}

            {productError ? (
              <div className="alert alert-danger">{productError}</div>
            ) : null}

            {loading ? (
              <p>Loading Stripe-linked products...</p>
            ) : (
              <div className="checkout-test-grid">
                {this.renderProductList("Courses", products.courses || [])}

                {this.renderProductList(
                  "Subscriptions",
                  products.subscriptions || []
                )}

                <div>
                  <h2>Planning and Scanning</h2>
                  {products.pas ? (
                    <div className="checkout-product-row">
                      <span>{products.pas.name}</span>
                      <button
                        className="btn btn-pp"
                        onClick={this.startPasCheckout}
                      >
                        Checkout
                      </button>
                    </div>
                  ) : (
                    <p>PAS is not linked to a Stripe Price yet.</p>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  errors: state.errors
});

export default connect(
  mapStateToProps,
  { startStripeCheckout }
)(StripeCheckoutTest);
